import React from 'react';

function PeopleContainer() {
    return(
        <article className="layout-contents-container">
            <h1 className="hidden">People</h1>

            <section className="people-group">
                <h2 className="hidden">Principal</h2>

                <figure className="principal">
                    <div className="profile">
                        <div className="inner">
                            <img src="/assets/images/@temp/people_01@2x.jpg" alt=""/>
                        </div>
                    </div>
                    <figcaption className="info">
                        <p className="summary">
                            <strong className="name">Choi Wook</strong>
                            Architect, Principal<br/>
                            Domus Korea - Editor & Publisher<br/>
                            cwatopos@gmail.com<br/>
                        </p>
                        <p className="description">
                            Born in 1963, he studied bachelor degree of Architecture at Hong-Ik University in Seoul and graduated Dottre of Architecture at Venice Architecture School in Italy. Valparaiso foundation in Spain invested him with fellowship from Macdowell Colony, U.S.A. He was invited from Venice Biennale in 2006 and also his works were selected from Shenzhen-Hong Kong Biennale in 2007. He has done numerous projects such as Hakgojae Gallery, Dugahun, Hyundai Card Design Library, Hyundai Card Branch Office at Yeongdeungpo and etc.<br/>
                            He gained DFAA (Design for Asia Awards) with Hyundai Card Design Library in 2013 and Kim Jong Sung Awards with Hyundai Card Branch Office in 2014. Currently he is a president of ONE O ONE architects and visiting professor of architecture at Korea National University of Arts.
                        </p>
                    </figcaption>
                </figure>
            </section>


            <section className="people-group">
                <h2 className="hidden">Directors</h2>

                <ul className="list-people">
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_02@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_02@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_02@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_02@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                </ul>
            </section>


            <section className="people-group">
                <h2 className="hidden">Contributors</h2>

                <ul className="list-people">
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_03@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_02@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                    <li>
                        <figure className="person-item">
                            <div className="profile">
                                <div className="inner">
                                    <img src="/assets/images/@temp/people_02@2x.jpg" alt=""/>
                                </div>
                            </div>
                            <figcaption className="info">
                                <strong className="name">Hwang Sunyoung</strong>
                                <p>
                                    Architect, Project Manager<br/>
                                    ssuumm@101-architetcs.com<br/>
                                </p>
                            </figcaption>
                        </figure>
                    </li>
                </ul>
            </section>
        </article>
    );
}

export default PeopleContainer;

